import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/AuthContext";
import { Nav } from "@/components/Nav";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import CoachProfile from "@/pages/CoachProfile";
import Auth from "@/pages/Auth";
import MyBookings from "@/pages/MyBookings";
import CoachDashboard from "@/pages/CoachDashboard";
import VideoAnalysis from "@/pages/VideoAnalysis";
import AdminPayouts from "@/pages/AdminPayouts";
import AdminCoaches from "@/pages/AdminCoaches";
import AdminInsights from "@/pages/AdminInsights";
import AdminContent from "@/pages/AdminContent";
import About from "@/pages/About";
import LegalPage from "@/pages/LegalPage";
import { Footer } from "@/components/Footer";
import Progress from "@/pages/Progress";
import Camps from "@/pages/Camps";
import CampDetail from "@/pages/CampDetail";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";

const Protected = ({ children, coachOnly, adminOnly }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-20 text-center text-zinc-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (coachOnly && user.role !== "coach") return <Navigate to="/bookings" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <BrowserRouter>
        <AuthProvider>
          <Nav />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/coaches" element={<Browse />} />
            <Route path="/coaches/:id" element={<CoachProfile />} />
            <Route path="/video-analysis" element={<VideoAnalysis />} />
            <Route path="/camps" element={<Camps />} />
            <Route path="/camps/:id" element={<CampDetail />} />
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/bookings" element={<Protected><MyBookings /></Protected>} />
            <Route path="/coach/dashboard" element={<Protected coachOnly><CoachDashboard /></Protected>} />
            <Route path="/admin/payouts" element={<Protected adminOnly><AdminPayouts /></Protected>} />
            <Route path="/admin/coaches" element={<Protected adminOnly><AdminCoaches /></Protected>} />
            <Route path="/admin/insights" element={<Protected adminOnly><AdminInsights /></Protected>} />
            <Route path="/admin/content" element={<Protected adminOnly><AdminContent /></Protected>} />
            <Route path="/about" element={<About />} />
            <Route path="/disclosure" element={<LegalPage section="disclosure" />} />
            <Route path="/privacy" element={<LegalPage section="privacy" />} />
            <Route path="/terms" element={<LegalPage section="terms" />} />
            <Route path="/progress" element={<Protected><Progress /></Protected>} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
